import React from 'react';
import PropTypes from 'prop-types';

import SVGIcon from './svg-icon';

/**
 * Notification provides a standardized template for displaying an Edlio
 * notification. Used to display information that a user should pay attention
 * to, or displayed as a result of a user action.
 *
 * Uniform Dependencies
 * @requires css:components/notifications
 */
export default class Notification extends React.Component {
  render() {
    const { additionalClasses, margin, padding, width, mini, onClose, allowHTML } = this.props;
    const { type, message, buttonText, buttonOnClick } = this.props.data;

    const classes = `${type} edlio-notification uniform-notification ${additionalClasses} ${mini ? 'mini' : ''}`;

    let iconName = '';

    switch (type) {
      case 'confirmation':
        iconName = 'check';
        break;
      case 'alert':
        iconName = 'exclamation-triangle';
        break;
      case 'info':
        iconName = 'info-circle';
        break;
      case 'default':
        iconName = 'spike';
    }

    const styles = { margin, padding, width }

    if (mini) {
      styles.alignItems = 'center';
      styles.display = 'flex';
    }

    return (
      <div
        className={classes}
        style={styles}
      >
        <SVGIcon name={iconName} />
        <section className='message'>
          {
            message.headline
            &&
            <div>
              {typeof message.headline === 'string' && allowHTML ?
                <h1 className={'notification-title'} dangerouslySetInnerHTML={{ __html: message.headline }} />
                :
                <h1 className={'notification-title'}>{message.headline}</h1>
              }
            </div>
          }

          {
            message.sub 
            &&
            <div>
              {typeof message.sub === 'string' && allowHTML ?
                <p style={{ margin: mini ? '0' : null }} dangerouslySetInnerHTML={{ __html: message.sub }} />
                :
                <p style={{ margin: mini ? '0' : null }}>{message.sub}</p>
              }
            </div>
          }

          {
            buttonText
            &&
            <button
              className='button secondary'
              onClick={buttonOnClick}
            >
              {buttonText}
            </button>
          }
        </section>

        {!!onClose &&
        <button
          style={{ background: 'transparent', border: 'none' }}
          onClick={() => onClose && onClose()}
        >
          <SVGIcon
            name='times'
          />
        </button>
        }

      </div>
    )
  }
}

Notification.propTypes = {
  additionalClasses: PropTypes.string,
  margin: PropTypes.string,
  padding: PropTypes.string,
  width: PropTypes.string,
  mini: PropTypes.bool,
  allowHTML: PropTypes.bool,
  data: PropTypes.shape({
    type: PropTypes.oneOf(['confirmation', 'alert', 'info', 'default']).isRequired,
    message: PropTypes.shape({
      headline: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      sub: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    }),
    buttonText: PropTypes.string,
    buttonOnClick: PropTypes.func
  }),
  onClose: PropTypes.func
};

Notification.defaultProps = {
  type: 'default',
  allowHTML: true,
  additionalClasses: ''
};



// WEBPACK FOOTER //
// ./src/main/webapps/common/react/components/notification.js